/**
 * JSON-LD Schema.org structured data generators for Vallarta Pixel.
 */

const SITE_URL = "https://vallartapixel.com";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_82ee4e38-abb0-4bd3-985f-83a63905409f/artifacts/3xn4ya4w_Vallarta%20Pixel.png";
const SITE_NAME = "Vallarta Pixel – The PV Hub";

/** WebSite schema for the homepage */
export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE_URL,
  description: "Own a piece of Puerto Vallarta's most iconic digital billboard. Buy pixel blocks for $100/year.",
  publisher: {
    "@type": "Organization",
    name: "Vallarta Pixel",
    logo: { "@type": "ImageObject", url: LOGO_URL },
  },
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/blog?search={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
});

/** LocalBusiness schema for the About page */
export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: SITE_NAME,
  description: "The premier digital billboard for advertising in Puerto Vallarta. A 1000x100 interactive pixel grid where businesses showcase their brands.",
  url: `${SITE_URL}/about`,
  logo: LOGO_URL,
  image: LOGO_URL,
  telephone: "+1-720-991-2057",
  email: "ddarious@proton.me",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Puerto Vallarta",
    addressRegion: "Jalisco",
    addressCountry: "MX",
  },
  sameAs: [
    "https://www.instagram.com/VallartaPixelOfficial",
    "https://t.me/VallartaPixelOfficial",
  ],
});

/** FAQPage schema */
export const faqSchema = (questions) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: questions.map((q) => ({
    "@type": "Question",
    name: q.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: q.answer,
    },
  })),
});

/** BlogPosting schema */
export const blogPostSchema = ({ title, description, image, datePublished, author, url }) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline: title,
  description,
  image: image || LOGO_URL,
  datePublished,
  dateModified: datePublished,
  author: {
    "@type": "Person",
    name: author || "Vallarta Pixel",
  },
  publisher: {
    "@type": "Organization",
    name: "Vallarta Pixel",
    logo: { "@type": "ImageObject", url: LOGO_URL },
  },
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": url || SITE_URL,
  },
});

/** Product schema for the Buy page */
export const productSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Pixel Block – Vallarta Pixel",
  description: "Own a 10x10 pixel block on Puerto Vallarta's iconic digital billboard. Display your brand, logo, and link for one year.",
  image: LOGO_URL,
  brand: { "@type": "Brand", name: "Vallarta Pixel" },
  offers: {
    "@type": "Offer",
    price: "100.00",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
    priceValidUntil: new Date(new Date().getFullYear() + 1, 0, 1).toISOString().slice(0, 10),
    url: `${SITE_URL}/buy`,
  },
});

/** WebPage schema (generic) */
export const webPageSchema = ({ name, description, url }) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  name,
  description,
  url: url || SITE_URL,
  isPartOf: { "@type": "WebSite", name: SITE_NAME, url: SITE_URL },
});

/** BreadcrumbList schema */
export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: item.url ? `${SITE_URL}${item.url}` : undefined,
  })),
});
